import { render, staticRenderFns } from "./MailAddress.vue?vue&type=template&id=acf8a75a&"
import script from "./MailAddress.vue?vue&type=script&lang=js&"
export * from "./MailAddress.vue?vue&type=script&lang=js&"
import style0 from "./MailAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports